import { ComponentProps } from 'react';

import NumberWithTooltip from '@/components/shared/tooltips/NumberTooltip';
import useNFTData from '@/hooks/useNFTData';
import { IMoralisNFT } from '@/redux/loans/model';
import { displayRepay, USDDollarFormatter } from '@/utils/formatter';
import { cn } from '@/utils/helper';

import IconCheck from '../../../assets/icons/icon-check-small.svg';

type NewNFTCardProps = {
  asset: {
    image_url: IMoralisNFT['normalized_metadata']['image'];
    rarity: IMoralisNFT['rarity_rank'];
    name: IMoralisNFT['name'];
    floorPriceInUsd: string | number | null;
    token_id: IMoralisNFT['token_id'];
  };
} & ComponentProps<'div'>;

const NewNFTCard: React.FC<NewNFTCardProps> = ({ asset, className, ...props }) => {
  const { ETHPrice, existFloor } = useNFTData({ asset });

  return (
    <article className={cn('relative flex flex-col gap-2 p-6 pt-7 bg-white-100 dark:bg-jet-black-100 border border-t-transparent dark:border-x-coal-border border-x-coal-50', className)} {...props}>
      <div className='check hidden justify-center items-center absolute top-3 left-3 size-4 rounded-sm bg-primary'>
        <IconCheck />
      </div>
      <hgroup className='text-center'>
        <h3 className='title text-base font-semibold'>{asset.name}</h3>
        <p className='title text-xs font-normal'>#{asset.token_id}</p>
      </hgroup>

      <img src={asset.image_url || '/placeholder.png'} className='w-full aspect-square object-cover' alt='img' />

      <ul className='flex justify-between items-center'>
        <li className='flex flex-col'>
          <p className='text-xs/4 font-medium'>Floor</p>
          <NumberWithTooltip fullNumber={ETHPrice} symbol='ETH'>
            <p className='text-xs/4 font-normal'>{displayRepay(ETHPrice)} ETH</p>
          </NumberWithTooltip>
        </li>
        <li className={cn('flex flex-col items-center')}>
          <p className='text-xs/4 font-medium'>Trait</p>
          <NumberWithTooltip fullNumber={ETHPrice}>
            <p className='text-xs/4 font-normal'>{existFloor ? displayRepay(USDDollarFormatter(existFloor)) : 'N/A'}</p>
          </NumberWithTooltip>
        </li>
      </ul>
    </article>
  );
};

export default NewNFTCard;
